@if (item()) {
  <div
    class="d-flex flex-row py-tiny gap-minus w-100 cursor-pointer"
    (click)="handleClick()"
  >
    <!-- Icon -->
    <div class="d-flex flex-column justify-content-start justify-align-start">
      @if (imageMode() === 'framed-icon') {
        <common-ui-components-framed-icon
          [type]="item()!.image.type"
          [enableMixedBlendMode]="mixedBlendModeEnabled()"
          [size]="'SMALL'"
          iconStyle="color: {{ item()!.image.color }}"
          [icon]="item()!.image.name ? item()!.image.name : 'digipay'"
          [iconType]="'due'"
          [trackerIdPrefix]="item()!.image.name ? item()!.image.name : 'digipay'"
        ></common-ui-components-framed-icon>
      } @else {
        <common-ui-components-category-image [image]="item()!.image.name"></common-ui-components-category-image>
      }
    </div>
    <!-- End Icon -->
    <div
      class="d-flex flex-row gap-small w-100"
      [ngClass]="{ 'border-b-300 border-color-air': item()!.divider, 'overflow-hidden': enableSingleLineMode() }"
    >
      <div class="d-flex pb-medium gap-small w-100">
        <div class="d-flex flex-column gap-tiny texts-wrapper">
          <div class="d-flex gap-tiny align-items-center flex-basis-1">
            <span
              class="text-onback-high st-8 my-atom"
              [ngClass]="{ 'single-line': enableSingleLineMode() }"
              >{{ item()?.title }}</span
            >
            @if (item()?.badge) {
              <ngx-badge
                [status]="item()!.badge!.status ?? 'info'"
                [mode]="item()!.badge!.mode ?? 'bold'"
                [size]="'sm'"
                >{{ (item()?.badge)!.text }}
              </ngx-badge>
            }
            @if (item()?.score) {
              <common-rate-count
                [rateAmount]="item().score.amount"
                [rateCount]="item().score.count"
                [size]="'sm'"
              ></common-rate-count>
            }
          </div>
          <div
            class="d-flex gap-tiny"
            [ngClass]="{ 'text-wrap': !enableSingleLineMode() }"
          >
            <span
              class="my-atom c-3 text-onback-medium"
              [ngClass]="{ 'single-line': enableSingleLineMode() }"
              >{{ item()!.subTitleNormal }}</span
            >
            @if (!hideSubtitleBold()) {
              <span
                class="my-atom c-1 text-onback-medium"
                [ngClass]="{ 'single-line': enableSingleLineMode() }"
                >{{ item()!.subTitleBold }}</span
              >
            }
          </div>
        </div>
      </div>
      @if (!hideButton()) {
        <div class="d-flex item-overview-icon align-items-start py-low">
          <ngx-button
            [mode]="'icon-only'"
            [size]="'small'"
            [style]="'tinted-on-elevated'"
            [leftIcon]="{ name: 'arrow-left' }"
            [brandButton]="false"
          >
          </ngx-button>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="d-flex py-tiny gap-medium w-100">
    <div class="d-flex justify-content-center align-items-center p-small radius-medium surface-back size-48">
      <lib-ngx-skeleton-loading
        [width]="'100%'"
        [height]="'100%'"
      ></lib-ngx-skeleton-loading>
    </div>
    <div class="d-flex flex-column pb-medium gap-minus flex-basis-1">
      <lib-ngx-skeleton-loading
        [width]="'100px'"
        [height]="'16px'"
      ></lib-ngx-skeleton-loading>
      <lib-ngx-skeleton-loading
        [width]="'100px'"
        [height]="'16px'"
      ></lib-ngx-skeleton-loading>
    </div>
  </div>
  <lib-ngx-skeleton-loading></lib-ngx-skeleton-loading>
}
